import React from "react"
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaTiktok,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-white text-gray-700 border-t border-gray-200 px-6 py-16">
      <div className="max-w-6xl mx-auto grid gap-10 md:grid-cols-4">
        {/* About Section */}
        <div>
          <h4 className="text-xl font-bold mb-4 text-gray-900">About PayOnewallet</h4>
          <p className="text-sm leading-relaxed mb-4">
            Pay1One Wallet is a secure digital payment system for hospitals, enabling patients to fund accounts and pay for services easily.
          </p>
          <p className="text-sm leading-relaxed">
            It integrates with hospital systems to ensure accurate payments and transparency.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xl font-bold mb-4 text-gray-900">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li className="hover:text-indigo-600 cursor-pointer transition-colors">
              FAQ
            </li>
            <li className="hover:text-indigo-600 cursor-pointer transition-colors">
              Safety Tips
            </li>
            <li className="hover:text-indigo-600 cursor-pointer transition-colors">
              Terms
            </li>
            <li className="hover:text-indigo-600 cursor-pointer transition-colors">
              Cookie Policy
            </li>
            <li className="hover:text-indigo-600 cursor-pointer transition-colors">
              Privacy Settings
            </li>
          </ul>
        </div>

        {/* Contact Us */}
        <div>
          <h4 className="text-xl font-bold mb-4 text-gray-900">Contact Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <FaEnvelope className="text-green-600 mt-0.5 shrink-0" />
              <a href="mailto:support@uchselfservice.net" className="hover:text-green-700 hover:underline">
                support@uchselfservice.net
              </a>
            </li>
            <li className="flex items-start gap-2">
              <FaWhatsapp className="text-green-600 mt-0.5 shrink-0" />
              <a href="https://wa.me/message/UCH" target="_blank" rel="noopener noreferrer" className="hover:text-green-700 hover:underline">
                Chat on WhatsApp
              </a>
            </li>
            <li className="text-gray-500 text-xs mt-2 bg-green-50 border border-green-100 rounded-lg px-3 py-2">
              🟢 Support available <strong>24/7</strong>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h4 className="text-xl font-bold mb-4 text-gray-900">Follow Us</h4>
          <div className="flex flex-wrap gap-2">
            {[
              { icon: <FaFacebookF />, href: "#" },
              { icon: <FaInstagram />, href: "#" },
              { icon: <FaXTwitter />, href: "#" },
              { icon: <FaYoutube />, href: "#" },
              { icon: <FaTiktok />, href: "#" },
            ].map(({ icon, href }, i) => (
              <a key={i} href={href}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-green-600 hover:text-white transition-colors">
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-200 mt-12 pt-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} PayOnewallet. UCH, All rights reserved.
      </div>
    </footer>
  )
}
